import gql from 'graphql-tag';

export const getFacilityQRCodeURL = gql`
  query getFacilityQRCodeURL($facilityUid: String!) {
    getFacilityQRCodeURL(facilityUid: $facilityUid)
  }
`;
